exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".item[data-v-22dd14eb]{border-bottom:1px solid #d3d3d3;padding:10px 0;width:100%}.item[data-v-22dd14eb]:first-child{padding-top:0}.item[data-v-22dd14eb]:last-child{border:none}@media only screen and (min-width:500px){.item[data-v-22dd14eb]{padding:0 10px;border-right:1px solid #d3d3d3;border-bottom:none}.item[data-v-22dd14eb]:first-child{padding-left:0}}.item__title[data-v-22dd14eb]{font-size:10px;line-height:1.3;text-transform:uppercase;letter-spacing:.03em}.item__value[data-v-22dd14eb]{font-size:16px;line-height:1.4;font-weight:700}@media screen and (min-width:360px){.item__value[data-v-22dd14eb]{font-size:18px}}.item__value.green[data-v-22dd14eb]{color:#77b97e}.item__value.red[data-v-22dd14eb]{color:#ab3b3b}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-22dd14eb","scoped":true,"hasInlineConfig":true}!./node_modules/stylus-loader!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/profile/views/certificate/components/score/components/item/Item.vue
// module id = f1b98ff5fdb58a2663db
// module chunks = 9